
import "./index.scss";

import React, {useState, useEffect} from 'react';
import ReactDOM from 'react-dom/client';
import "firebase/auth";
import "firebase/firestore";
import { Provider, useDispatch, useSelector } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";

import store from './Store';
import {
  selectReduxSlice,
  getData,
  findInitialPlayerLevelOnLoad,
} from "./Store/store";
import App from './App';
import LoadingScreen from './Components/LoadingScreen';
// import config from './config/RedLake/config';
// import config from './config/Salish/config';
// import config from './config/FortBelknap/config';
// import config from './config/Pokagon/config';
import config from './config/WestBank/config';

let scoreData = [];
let checkDataArray = [];
let gameList = [];

const setInitialLevelData = (
  gameData,
  setInitialLevel,
  levelData,
  setLevelData
) => {
  let newLevelData = levelData;
  if (localStorage[`KZ_${config.Language}_LevelData`] && localStorage[`KZ_${config.Language}_LevelData`].length > 2) {
    newLevelData = JSON.parse(localStorage[`KZ_${config.Language}_LevelData`]);
    if (newLevelData.type === "string") {
      newLevelData = JSON.parse(newLevelData);
    }
  } else {
    let gameTypes = config.PossibleGames;
    gameTypes.forEach((gameType) => {
      if (
        gameType !== "Bingo" &&
        gameType !== "Fill In The Blank" &&
        gameType !== "Story Book" &&
        gameType !== "Crocodile" &&
        gameType !== "Solve It 2" &&
        gameType !== "Solve It" &&
        gameType !== "Verb Activity"
      ) {
        if (!gameList.includes(gameType)) {
          gameList.push(gameType);
        }
      }
    });
    gameList.forEach((gameType) => {
      let cats = ["2", "3", "4", "5"];
      cats.forEach((cat) => {
        newLevelData.push({
          gameType: `${cat} Categories`,
          spreadGameType: gameType,
          category: [],
          levelEasy: 0,
          levelMedium: 0,
          levelHard: 0,
          categoryEasy: [],
          categoryMedium: [],
          categoryHard: [],
        });
      });
    });
    let dataToRun = gameData.filter((d) => isNaN(d.Key.length));
    dataToRun.forEach((game) => {
      gameList.forEach((gameType) => {
        if (!checkDataArray.includes(`${gameType}${game.category}`)) {
          checkDataArray.push(`${gameType}${game.category}`);
          newLevelData.push({
            gameType: gameType,
            spreadGameType: gameType,
            category: game.category,
            levelEasy: 0,
            levelMedium: 0,
            levelHard: 0,
            categoryEasy: [],
            categoryMedium: [],
            categoryHard: [],
          });
        }
      });
    });
  }
  setLevelData(newLevelData);
  setInitialLevel(true);
};

const setInitialScoreData = ({
  data,
  GoldStar,
  setInitialScore,
  dispatch
}) => {
  // TODO: check if param "data" length is the same as the localStorage data. If
  // they don't match, games have either been removed or added and the local
  // data must be altered
  let currentStars = 0;
  let totalStars = 0;
  if (
    localStorage[`KZ_${config.Language}_ScoreData`] &&
    localStorage[`KZ_${config.Language}_ScoreData`].length > 2
  ) {
    scoreData = JSON.parse(localStorage[`KZ_${config.Language}_ScoreData`]);
    if (scoreData.type === "string") {
      scoreData = JSON.parse(scoreData);
    }
    scoreData.forEach((indivGame) => {
      // Finding currentStars //
      let scores = indivGame.difficultyScores;
      let indivGameStars = 0;
      if (scores !== undefined) {
        indivGameStars =
          scores.easy.stars + scores.medium.stars + scores.hard.stars;
      }
      currentStars = currentStars + indivGameStars;
      // Finding totalStars //
      if (indivGame.secondType === "none") {
        totalStars = totalStars + 9;
      } else {
        totalStars = totalStars + 18;
      }
    });
  } else {
    let dataToRun = data.filter((d) => isNaN(d.Key.length));
    dataToRun.forEach((game) => {
      config.PossibleGames.forEach((gameType) => {
        let shortGameType = gameType.replaceAll(" ", "").replaceAll("-", "");
        let scoreType = GoldStar.find((type) => type.game === shortGameType);
        if (
          scoreType === undefined &&
          gameType !== "Verb Activity" &&
          gameType !== "From Me To You"
        ) {
          // TODO: Double check that this is '&&' and not '||'
          return;
        }
        let easyDifficulty = game[gameType];
        if (scoreType.secondType === "none") {
          totalStars = totalStars + 9;
        } else {
          totalStars = totalStars + 18;
        }
        if (easyDifficulty !== null) {
          let difs = {easy: easyDifficulty, medium: easyDifficulty + 1, hard: easyDifficulty + 2};
          let difficultyScores = {};
          let keys = Object.keys(difs);
          keys.forEach((key) => {
            difficultyScores[key] = {
              difficulty: difs[key],
              correct: 0,
              incorrect: 0,
              score: 0,
              time: 0,
              stars: 0,
              firstStars: 0,
              secondStars: 0,
              firstNextGoals: null,
              secondNextGoals: null,
            };
          });
          scoreData.push({
            difficultyScores: difficultyScores,
            Key: `${game.Key}${gameType}`,
            scoreType: scoreType.scoreType,
            category: game.category,
            gameType: gameType,
            target: game.target,
            firstType: scoreType.type,
            secondType: scoreType.secondType,
          });
        }
      });
    });
  }
  dispatch(findInitialPlayerLevelOnLoad(currentStars, totalStars));
  setInitialScore(true);
};

const saveData = (score, level) => {
  localStorage.clear();
  localStorage.setItem(
    `KZ_${config.Language}_ScoreData`,
    JSON.stringify(score)
  );
  localStorage.setItem(
    `KZ_${config.Language}_LevelData`,
    JSON.stringify(level)
  );
};

const SendData = () => {
  const dispatch = useDispatch();
  const reduxState = useSelector(selectReduxSlice);
  const [initialScore, setInitialScore] = useState(false);
  const [initialLevel, setInitialLevel] = useState(false);
  const [levelData, setLevelData] = useState([]);
  useEffect(() => {
    config.SheetsToPull.forEach((d) => {
      dispatch(getData(d.collection, d.nameToSave));
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  if (reduxState?.firebaseSheetsPulled.length >= config.SheetsToPull.length) {
    if (initialScore === false) {
      setInitialScoreData({
        data: reduxState.gameData,
        GoldStar: reduxState.goldStar,
        setInitialScore: setInitialScore,
        dispatch: dispatch,
      });
    }
    if (initialLevel === false) {
      setInitialLevelData(
        reduxState.gameData,
        setInitialLevel,
        levelData,
        setLevelData
      );
    }
    return (
      <Router>
        <App
          style={{width: '100%', height: '100%', backgroundColor: 'red'}}
          scoreDataProp={scoreData}
          levelDataProp={levelData}
          saveData={saveData}
          config={config}
        />
      </Router>
    );
  } else {
    return <LoadingScreen />;
  }
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <SendData />
  </Provider>
);
// root.render(
//   <React.StrictMode>
//     <Provider store={store}>
//       <SendData />
//     </Provider>
//   </React.StrictMode>
// );
